"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import { useCart } from "@src/contexts/CartContext";
import { toast } from "react-toastify";
import Loading from "@src/app/loading";

const Link = dynamic(() => import("next/link"), { ssr: false });
const ProductSlider = dynamic(() => import("@src/components/template/Home/ProductSlider"), {
  ssr: false,
});

const CardDetailsClient = ({ productProp, data, lastName }) => {
  const product = productProp;
  const [quantity, setQuantity] = useState(1);
  const { addCard } = useCart();

  if (!product) return <Loading />;

  return (
    <>
      <div className="bg-hederGradient flex h-18 w-full items-center">
        <ul className="container mx-auto flex h-full items-center justify-start gap-x-4 px-6 text-sm sm:px-32 lg:text-lg">
          <Link href="/" className="text-nowrap text-white hover:underline">
            مارول لایف
          </Link>
          <li className="text-white">/</li>
          <Link href="/book" className="text-nowrap text-white hover:underline">
            کتاب
          </Link>
          <li className="text-white">/</li>
          <p className="text-white">{product?.title_fa}</p>
        </ul>
      </div>

      <div className="container mx-auto px-4 pt-8 sm:px-24">
        <div className="flex flex-col gap-6 lg:h-[500px] lg:flex-row">
          <div className="flex-1">
            <img
              src={product?.img}
              alt={product?.title_fa}
              className={`mb-2 h-[350px] w-full object-contain sm:h-[500px] sm:w-[500px]`}
            />
          </div>

          <div className="flex-1">
            <h2 className="mb-4 text-2xl font-bold sm:text-3xl">{product?.title_fa}</h2>
            <p className="text-blue mb-5 text-xl font-black sm:text-2xl">
              {Number(product?.price).toLocaleString()} تومان
            </p>
            {product?.description && <hr />}

            <p className="my-5 text-base lg:text-[17.5px]">
              {product?.description?.length > 420
                ? `${product.description.slice(0, product.description.lastIndexOf(" ", 420))}...`
                : product?.description}
            </p>

            {product?.description && <hr />}

            <div className="my-5 flex items-center gap-x-4">
              <h4 className="mr-4 font-bold">تعداد:</h4>
              <div className="flex items-center rounded-sm border">
                <button
                  onClick={() => setQuantity(quantity > 1 ? quantity - 1 : 1)}
                  className="p-2"
                >
                  -
                </button>
                <span className="px-4">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="p-2">
                  +
                </button>
              </div>
              <button
                onClick={() => {
                  if (lastName) {
                    for (let i = 0; i < quantity; i++) {
                      addCard(product._id);
                    }
                  } else {
                    toast.warning("لطفا ثبت‌نام بفرمایید");
                  }
                }}
                className="bg-buttonGradient cursor-pointer rounded-lg px-6 py-3 text-white"
              >
                افزودن به سبد خرید
              </button>
            </div>
          </div>
        </div>

        <div>
          <ProductSlider
            key="1"
            product={data}
            path={product?.category == "book" ? "/book" : "/silvershot"}
            title="محصولات مرتبط"
            type={product?.category == "book" ? "book" : "silver"}
            isAuthenticated={true}
            lastName={lastName}
          />
        </div>
      </div>
    </>
  );
};

export default CardDetailsClient;
